import React from "react";
import { BaseComponent } from "../baseComponent/BaseComponent"
import { BaseLotInfoByOrganizator } from "../../../Models/Lots/LotInfoByOrganizator"
import { OpenAuction } from "./OpenAuction";


interface IPropsType {
    // информация о лоте
    lot?: BaseLotInfoByOrganizator,
    onRemove: (id) => any
    // режим отображения данных. Возможны два варината: Edit и View. 
    // mode: string 
}

export class OpenAuctionOrganizer extends OpenAuction {
    constructor(props: IPropsType) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                {this.ShortInfoLot()}
            </React.Fragment>
        );
    }
}